export const AllCups = {
  ExtinctionCup_000: {
    id:'ExtinctionCup_000',name: 'Extinction Cup',rewardsType: 'point', taskPoints: 2000, type: 'Extinction',players:88080, startTime: new Date('2025-03-01T10:00:00') ,Round:3,
    thumbnail:['/thumbnail/thumbnail01','/thumbnail/thumbnail02','/thumbnail/thumbnail03'],background: ['/asset/Free_bg.jpg']
  },
  UsdtCup_000:{id:'UsdtCup_000',name: 'USDT Cup',rewardsType: 'point', taskPoints: 2000, type: 'USDT',players:88080, startTime: new Date('2025-03-01T10:00:00'), Round:2, background: ['/asset/USDT_bg.jpg']},
  BallsCup_000:{id:'BallsCup_000',name: '$BALL Cup',rewardsType: 'point', taskPoints: 2000, type: 'USDT',players:88080, startTime: new Date('2025-03-05T10:00:00'), Round:4, background: ['/asset/BALL_bg.jpg']},
};

